import React from 'react';
import { Box, Typography } from '@mui/material';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts';
import moment from 'moment';

function OtaWiseRoomNightSales({ data, colors }) {
    return (
        <Box backgroundColor={colors.primary[400]} p="20px" height="100%">
            <Typography variant="h5">
                OTA WISE ROOM NIGHT SALES ON
            </Typography>
            <Typography variant="h4" fontWeight="600" textTransform={"uppercase"}>
                {moment().format("MMM-YYYY")}
            </Typography>
            {data?.length ? (
                <Box
                    width={"100%"}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    mt={1}
                    ml={4}
                >
                    <PieChart
                        colors={['red', 'orange', 'blue']}
                        series={[
                            {
                                arcLabel: (item) => `${item.value}`,
                                arcLabelMinAngle: 45,
                                outerRadius: 100,
                                paddingAngle: 1,
                                cornerRadius: 1,
                                data,
                            },
                        ]}
                        sx={{
                            [`& .${pieArcLabelClasses.root}`]: {
                                fill: 'white',
                                fontWeight: 'bold',
                            },
                            // '--ChartsLegend-itemWidth': '130px',
                            // '--ChartsLegend-labelSpacing': '5px',
                            // '--ChartsLegend-rootSpacing': '5px',
                        }}
                        width={400}
                        height={300}
                        legend={{
                            position: { vertical: "bottom", horizontal: "middle" },
                        }}
                    />
                </Box>
            ) : (
                <Typography mt={15} mb={15} textAlign="center">
                    No Data Available...
                </Typography>
            )}
        </Box>
    )
}

export default OtaWiseRoomNightSales;